export interface GHpNormData {
    code: number;
    msg: string;
    data: object;
}

//获取本地信息
export interface GHpLocalPropertyInfo {
    //IP地址
    clientIp: string;
    //所在省份
    province: string;
    //所在城市
    city: string;
}
export enum ApiMethod {
    GET,
    POST,
    SEND,
}

export interface ApiQuery {
    method?: ApiMethod;
    head?: string;
    body?: any;
    response?: any;
}

// export interface AqLoginBody {
//     platform : string,
//     account ?: string,
//     nickName?: string,
//     headData?: string,
//     code?: string,
//     anonymousCode?: string,
//     province?: string,
//     clickId?: string
// }

// export interface AqLoginRes {
//     account: string,
//     nickName: string,
//     headData: string,
//     coin: number,
//     country: string,
//     province: string,
//     city: string
// }

// export interface AqLoginReq extends ApiQuery {
//     body?: AqLoginBody,
//     res?: AqLoginRes
// }

// export const AqLoginMsg: AqLoginReq = {
//     head: `${TWSJ_API}/login`,
// }

// export interface AqUserWatchBody {
//     platform : string,
//     account: string
// }

// export interface AqUserWatchRes {
//     code : number,
//     msg: string
// }

// export interface AqUserWatchReq extends ApiQuery {
//     body?: AqUserWatchBody,
//     res?: AqUserWatchRes
// }

// export const AqUserWatchADMsg: AqUserWatchReq = {
//     head: `${TWSJ_API}/watchAD`,
// }
export enum Platform {
    //未知
    NULL,
    //H5
    H5,
    //字节跳动系平台
    TT,
    //
    VIVO,
    //
    OPPO,
    //
    KS,
    //
    WX,
    //
    QQ,
    //
    TAO_BAO
}


export const ECPM_MANAGE_API: string = '/ecpm_manage';

export interface AqUserLoginBody {
    platform: string,
    account?: string,
    nickName?: string,
    gameId?: string,
    secretId?:string,
    headData?: string,
    code?: string,
    anonymousCode?: string,
    clickId?: string
}

export interface AqUserLoginRes {
    account: string,
    nickName: string,
    headData: string,
}

export interface AqUserLoginReq extends ApiQuery {
    body?: AqUserLoginBody,
    res?: AqUserLoginRes
}

export const AqLoginMsg: AqUserLoginReq = {
    head: `${ECPM_MANAGE_API}/login`,
}


export interface AqUserWatchBody {
    platform: string,
    account: string,
    gameId: string,
}

export interface AqUserWatchRes {
    code: number,
    msg: string
}

export interface AqUserWatchReq extends ApiQuery {
    body?: AqUserWatchBody,
    res?: AqUserWatchRes
}

export const AqUserWatchADMsg: AqUserWatchReq = {
    head: `${ECPM_MANAGE_API}/watchAD`,
}

export const TURN_OVER_API: string = '/resigned_server';

export interface AqSensitiveBody {
    checkStr: string
}

export interface AqSensitiveRes {
    taskList: ksTask[]
}

export interface ksTask{
    task_id:string,
    title:string,
    desc:string,
    icon_urls:string[],
    status_detail:ksTaskStatusDetail,
    award_detail:ksTaskAwardDetail,
    assist_user_infos:ksTaskAssistUserInfo
}

export interface ksTaskStatusDetail{
    status:number,//1:待领取，2:进行中，3:已完成
    display_text:string,
    completed_time:number,
    max_completed_times:number
}

export interface ksTaskAwardDetail{
    award_id:string,
    name:string,
    count:number,
    icon_urls:string[]
}

export interface ksTaskAssistUserInfo{
    encrypted_user_id:string,
    open_id:string,
    user_level:number,//1:高价值,2:中价值,3:低价值
    user_name:string,
    head_img:string,
    assist_time:number
}

export interface ksTaskResponse{
    result:number,
    msg:string,
    tasks:ksTask[]
}

export interface ApiSensitiveReq extends ApiQuery {
    body?: AqSensitiveBody,
    res?: AqSensitiveRes
}

export const ApiSensitiveMsg: ApiSensitiveReq = {
    head: `${TURN_OVER_API}/sensitive`,
}
